import { Link } from "react-router";
import Chip from "@/components/Chip/Chip";
import "./SponsorBanner.css";

// -----------------------------------------------------------------------------------

export default function SponsorBanner() {
	const chipsArr = [
		{ label: "Knowledge Transfer & Community Building" },
		{ label: "Software Tools" },
		{ label: "Data Capture" },
		{ label: "Hardware" },
		{ label: "Fundamental Science" },
		{ label: "Validation & Benchmarking" },
		{ label: "Simulation Infrastructure" },
	];

	// -----------------------------------------------------------------------------------

	return (
		<section className="sponsor-banner">
			<div className="sponsor-banner-text-wrapper">
				<Link to="/build" className="sponsor-big-text">
					Sponsor or work on brain emulation&nbsp;→
				</Link>

				<p className="sponsor-small-text">
					Let's build out the brain emulation tech tree
				</p>
			</div>

			{/* ----------------------------------------------------------------------------- */}

			<div className="chips-wrapper">
				{chipsArr.map((chip) => (
					<Chip
						key={chip.label}
						label={chip.label}
						color="var(--accent)"
						bgColor="var(--bg)"
					/>
				))}
			</div>
		</section>
	);
}
